import PropTypes from 'prop-types'
import { Box, Heading, HStack, Link, Text, VStack } from '@chakra-ui/react'
import React from 'react'
import { useLabels } from '../../../../utils/hooks/useLabels/useLabels'
import { colors } from '../../../../utils/theme/styles'
import InfoLabel from '../../../EmployeeDetails/components/InfoLabel'
import { ItemWrapper } from './CompanyInfo'

export default function BillingData({ data }) {
  const [email, setEmail] = React.useState('')
  const [showEmail, setShowEmail] = React.useState(false)
  const [formattedEmail, setFormattedEmail] = React.useState('')

  React.useEffect(() => {
    if (data?.sEmailFactura) {
      setEmail(data.sEmailFactura)
      setFormattedEmail(
        `*****${data.sEmailFactura?.split('@')[0].slice(-2)}@*****.${
          data.sEmailFactura?.split('@')[1].split('.')[1]
        }`,
      )
    }
  }, [data?.sEmailFactura])

  const { texts } = useLabels()
  return (
    <VStack spacing="20px" w="100%" alignItems="flex-start">
      <Box>
        <Heading color={colors.gray[800]} variant="h6">
          {texts.billing_data}
        </Heading>
      </Box>
      <VStack w="100%" alignItems="flex-start">
        <ItemWrapper>
          <InfoLabel title={texts.invoice_for} value={data.sFacturarPor} />
        </ItemWrapper>
        <ItemWrapper>
          <InfoLabel
            title={texts.payment_deadline}
            value={`${data.sPlazoPago} días`}
          />
        </ItemWrapper>
        <HStack
          w="100%"
          justifyContent="flex-start"
          alignItems="center"
          wrap="wrap"
        >
          <ItemWrapper>
            <InfoLabel
              title={texts.email_billing}
              value={showEmail ? email : formattedEmail}
            />
          </ItemWrapper>
          <ItemWrapper>
            <div
              style={{
                height: 55,
                paddingTop: 17,
                alignItems: 'center',
                display: 'flex',
              }}
            >
              <Link
                style={{ color: '#aaa', textDecoration: 'underline' }}
                onClick={() => {
                  setShowEmail(!showEmail)
                }}
              >
                <Text textDecor="underline" cursor="pointer" variant="caption1">
                  {texts.view_email}
                </Text>
              </Link>
            </div>
          </ItemWrapper>
        </HStack>
      </VStack>
    </VStack>
  )
}

BillingData.propTypes = {
  data: PropTypes.shape({
    sEmailFactura: PropTypes.string,
    sFacturarPor: PropTypes.string,
    sPlazoPago: PropTypes.string,
  }),
}
